import { Component } from '@forge/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@forge/events';

/**
 * A custom element that renders a media gallery.
 *
 * @typedef {object} Refs
 * @property {import('./zoom-dialog').ZoomDialog} [zoomDialogComponent] - The zoom dialog component.
 * @property {import('./slideshow').Slideshow} [slideshow] - The slideshow component.
 * @property {HTMLElement[]} [media] - The media elements.
 *
 * @extends Component<Refs>
 */
export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }

  /**
   * Handles a variant update event by replacing the current media gallery with a new one.
   *
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;

    if (!source) return;
    const newMediaGallery = source.querySelector('forge-media-gallery');

    if (!newMediaGallery) return;

    this.replaceWith(newMediaGallery);
  };

  /**
   * Handles the 'zoom-media:selected' event.
   * @param {ZoomMediaSelectedEvent} event - The zoom-media:selected event.
   */
  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  /**
   * Zooms the media gallery.
   *
   * @param {number} index - The index of the media to zoom.
   * @param {PointerEvent} event - The pointer event.
   */
  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('forge-media-gallery')) {
  customElements.define('forge-media-gallery', MediaGallery);
}

function selectBundleVariantMedia(event) {
  const variantId = String(event.detail?.variantId || '').split('/').pop();
    if (!variantId) return;

      const wrapper = Array.from(document.querySelectorAll('[data-product-variants]')).find((element) => {
          try {
                return JSON.parse(element.dataset.productVariants || '[]').some((variant) => String(variant.id) === variantId);
                    } catch (_) {
                          return false;
                              }
                                });
                                  if (!wrapper) return;

                                    const variant = JSON.parse(wrapper.dataset.productVariants).find((item) => String(item.id) === variantId);
                                      const imagePath = variant?.featured_image?.src ? new URL(variant.featured_image.src, window.location.href).pathname : null;
                                        const gallery = wrapper.closest('.shopify-section')?.querySelector('forge-media-gallery');
                                          const slides = gallery?.slideshow?.slides;
                                            if (!imagePath || !slides?.length) return;

                                              const index = Array.from(slides).findIndex((slide) => {
                                                  const image = slide.querySelector('img');
                                                      return image && new URL(image.currentSrc || image.src, window.location.href).pathname === imagePath;
                                                        });
                                                          if (index >= 0) gallery.slideshow.select(index, undefined, { animate: true });
                                                          }

                                                          document.addEventListener('forge:bundleSelected', selectBundleVariantMedia);
                                                          
                                                          document.addEventListener('change', (event) => {
                                                            if (!event.target.matches('select.forge-volume-variant')) return;
                                                              selectBundleVariantMedia({ detail: { variantId: event.target.value } });
                                                              });
                                                              